module.exports = __webpack_public_path__ + "img/5fce3f4.png";